<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 16:49:50
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-12 22:27:33
 * @Description: 未审核数
 -->
<template>
  <div class="list-table-not-approval-num cursor">
    <span @click="toExamineApprove(scope.row._id)">
      {{ scope.row.notApprovalNum }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ListTableNotApprovalNum',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    toExamineApprove (_id) {
      this.$router.push({
        path: '/business-school/examination-manage/paper-examine-approve',
        query: {
          paperId: _id
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.list-table-not-approval-num {
  color: #009cff;
  margin-left: 16px;
}
</style>
